module.exports = "/images/nuclear-power-plant@3x.png?16c3d28fccba23987782dd0d6517e390";